import type {ThesaurusAction} from 'types';
import {FieldExtensionEnum} from 'sceneExtensions/types';
import {useFieldExtensionContext} from 'sceneExtensions/hooks';
import type {
  MultiThesaurusFieldConfig,
  MultiThesaurusFieldExtension,
  MultiThesaurusValue,
} from '../types';

export const useMultiThesaurusFieldExtension =
  (): MultiThesaurusFieldExtension => {
    return useFieldExtensionContext<
      FieldExtensionEnum.multiThesaurusEdit,
      MultiThesaurusValue,
      MultiThesaurusValue,
      ThesaurusAction,
      MultiThesaurusFieldConfig
    >(FieldExtensionEnum.multiThesaurusEdit);
  };
